import type {
  SourcingCandidate,
  SourcingCandidateRow,
  SourcingSpecializationOption,
  SourcingTechnologyOption,
} from '../types';

type CandidateSpecialization = SourcingCandidate['specializations'][number];

const getQualificationLevelWeight = (level: CandidateSpecialization['qualificationLevel']): number => {
  if (level === 'N_A') return -1;
  return Number(level.slice(1));
};

const mapCandidateToRow = (
  candidate: SourcingCandidate,
  specialization?: SourcingSpecializationOption,
  technology?: SourcingTechnologyOption,
): SourcingCandidateRow => {
  const matchingSpecializations = candidate.specializations.filter(
    item =>
      (!specialization || item.specialization === specialization.specialization) &&
      (!technology || item.technology === technology.technology),
  );

  const matchedSpecialization = matchingSpecializations.reduce<CandidateSpecialization | undefined>(
    (currentMax, item) => {
      if (!currentMax) return item;

      return getQualificationLevelWeight(item.qualificationLevel) >
        getQualificationLevelWeight(currentMax.qualificationLevel)
        ? item
        : currentMax;
    },
    undefined,
  );

  return {
    ...candidate,
    specialization: matchedSpecialization?.specialization ?? null,
    technology: matchedSpecialization?.technology ?? null,
    level: matchedSpecialization?.qualificationLevel ?? null,
    isLevelsConfirmed: matchedSpecialization?.isConfirmed ?? false,
  };
};

export default mapCandidateToRow;
